import { Cookies } from 'react-cookie-consent'
export default (cookieName: string, expirationTime: number) =>
  Cookies.set(cookieName, 'true', { expires: expirationTime })
